import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { enviarsms } from "../../../services/services";
import { getData } from "../../../services/library";

const ModalCambioDeEstadoSolicitud = ({
  open,
  onClose,
  nuevoEstado = null,
  idSolicitud,
  obtenerSolicitudes,
  mostrarAlertaTemporal,
}) => {
  const usuarioAutorizador = localStorage.getItem("user");
  const [solicitudInfo, setSolicitudInfo] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await getData(
        `/solicitudDePersonal/infoSolicitud/${idSolicitud}`,
        setSolicitudInfo
      );
      console.log("Solicitud Info:", solicitudInfo);
    };

    fetchData();
  }, [idSolicitud]);

  const mandarSmsAlCreadorDeLaSolicitud = (persona) => {
    const { nombrepila, apellido, puesto, celular, id_solicitud } = persona;
    if (celular) {
      const estadoActualizado =
        nuevoEstado === null
          ? "no fue autorizada y por lo tanto se elimino"
          : "fue autorizada y se encuentra en estado pendiente";
      const message = `Hola ${nombrepila} ${apellido}, te informamos que la solicitud de ${puesto} con el ID ${id_solicitud} ${estadoActualizado}.`;
      enviarsms(celular, message);
    } else {
      console.log("No se puede enviar SMS, el celular no está disponible.");
    }
  };

  const handleFunctionAuthorize = async (e) => {
    e.preventDefault();
    try {
      const url = `${UrlApi}/solicitudDePersonal/${idSolicitud}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          activa: nuevoEstado,
          autorizado_por: usuarioAutorizador,
        }),
      });

      if (!response.ok) throw new Error("Error al cambiar estado");

      const data = await response.json();
      console.log("Estado actualizado:", data);
      console.log("mandarSms persona:", solicitudInfo);

      obtenerSolicitudes();
      mandarSmsAlCreadorDeLaSolicitud(solicitudInfo);
      mostrarAlertaTemporal(
        `La solicitud de ${
          solicitudInfo.puesto
        } con ID ${idSolicitud} ha sido ${
          nuevoEstado ? "autorizada" : "eliminada"
        }.`,
        "success"
      );
      onClose();
    } catch (err) {
      console.error(err);
      onClose();
    }
  };

  const handleFunctionCancel = async (e) => {
    e.preventDefault();
    try {
      const url = `${UrlApi}/solicitudDePersonal/${idSolicitud}`;
      const response = await fetch(url, { method: "DELETE" });

      if (!response.ok) throw new Error("Error al eliminar");

      const data = await response.json();
      console.log("Solicitud eliminada:", data);
      obtenerSolicitudes();
      mandarSmsAlCreadorDeLaSolicitud(solicitudInfo);
      mostrarAlertaTemporal(
        `La solicitud de ${
          solicitudInfo.puesto
        } con ID ${idSolicitud} ha sido ${
          nuevoEstado ? "autorizada" : "eliminada"
        }.`,
        "success"
      );
      onClose();
    } catch (err) {
      console.error(err);
      onClose();
    }
  };

  const titulo =
    nuevoEstado === null
      ? "Eliminar solicitud"
      : "Cambiar estado de la solicitud";
  const handleFunction =
    nuevoEstado === null ? handleFunctionCancel : handleFunctionAuthorize;
  const texto =
    nuevoEstado === null
      ? "¿Esta seguro que quiere eliminar la solicitud? Esta accion es irreversible."
      : "¿Esta seguro que quiere cambiar el estado de la solicitud?";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {titulo}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          <Typography variant="h6" color="#000000" sx={{ fontWeight: "bold" }}>
            {texto}
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={(e) => {
              handleFunction(e);
            }}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCambioDeEstadoSolicitud;
